import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  getExam,
  getBizList
} from "../../api/service.js"

export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      cateExerciseList: [],
      isJx: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 12,
      },
    }
  },
  created() {
    this.getCateExerciseList()
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
  },
  methods: {
    //练习分类列表
    getCateExerciseList() {
      let url = "exercise/cateExerciseList";
      getExam(url).then(res => {
        if (res.success) {
          this.cateExerciseList = res.data;
          this.total = res.total;
        } else {
          this.$message.error(res.message)
        }
      })
    },
    goToExamList(type, cateId, catePatentId) {
      this.$router.push({
        path: "/examList",
        query: {
          type: type,
          cateId: cateId,
          catePatentId: catePatentId
        }
      });
    },
    currentChange(page) {
      this.queryParams.pageNum = page;
      this.getTestList();
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/exam/exam.js